/**
 * Redirections 301 des anciennes URLs WordPress (dj-val.fr) vers les routes
 * du site Lovable. Appliquées côté serveur par le catch-all `src/routes/$.tsx`.
 *
 * Le fichier `public/_redirects` n'est pas interprété par l'hébergement :
 * ces règles sont donc la source de vérité. Toute destination DOIT exister.
 * Les clés sont normalisées (minuscules, sans slash final).
 */
export const LEGACY_REDIRECTS: Record<string, string> = {
  // — Location de matériel —
  "/location-karaoke-avignon": "/location-karaoke-vaucluse",
  "/location-karaoke-cavaillon-avignon": "/location-karaoke-vaucluse",
  "/soiree-karaoke-avignon-vaucluse": "/soiree-karaoke-avignon",
  "/soiree-karaoke": "/soiree-karaoke-avignon",
  "/location-machine-a-mousse-vaucluse-bouches-du-rhone": "/location-materiel/machine-mousse",
  "/location-avec-installation/location-machine-a-mousse-vaucluse-drome-gard-ardeche-bouche-du-rhone":
    "/location-materiel/machine-mousse",
  "/location-materiel-sono-vaucluse": "/location-materiel",
  "/location-et-installation": "/location-materiel",
  "/location-avec-installation": "/location-materiel",
  "/loc-machine-a-bulles": "/location-materiel/machine-bulles",
  "/loc-machine-a-confettis": "/location-materiel/machine-confettis",
  "/loc-lumiere-noire-uv": "/location-materiel/lumiere-noire-uv",
  "/location-videoprojecteurs-ecrans-avignon": "/location-materiel/videoprojecteur",
  "/location-video-projecteur": "/location-materiel/videoprojecteur",
  "/location-photobooth-avignon-2": "/location-photobooth-avignon",
  "/location-canon-co2-pour-evenements": "/location-materiel/canon-co2",
  
  "/location-de-guirlandes-guinguette-a-avignon": "/location-materiel/guirlandes-guinguette",
  "/location-eclairage-avignon": "/location-materiel",
  "/location-machines-a-fumee-lourde-et-classique-led": "/location-materiel/machine-fumee-lourde",
  "/location-enceinte-avignon": "/location-materiel/enceintes-actives",
  "/sono-enceinte-test": "/location-materiel/enceintes-actives",
  "/location-micros-vaucluse": "/location-materiel/micros-hf",
  "/location-console-multi-pistes": "/location-materiel/console-pioneer",
  "/location-regie-dj-pioneer-2000nexus2-3000-cavaillon-vaucluse":
    "/location-materiel/console-pioneer",
  "/une-lyre-led-cest-quoi": "/location-materiel/lyres-led",
  "/location-lyre-led-avignon": "/location-materiel/lyres-led",

  // — Soirées à thème —
  "/soiree-fluo": "/soirees-thematiques/fluo",
  "/soiree-fluo-dj-professionnel": "/soirees-thematiques/fluo",
  "/soiree-co2": "/soirees-thematiques/co2",
  "/soiree-confettis": "/soirees-thematiques/confettis",
  "/soiree-tempete-de-bulles": "/soirees-thematiques/tempete-de-bulles",
  "/soiree-tempete-de-neige": "/soirees-thematiques/tempete-de-neige",

  // — Prestations / occasions —
  "/dj-pour-mairie-et-evenements-communaux": "/soirees-evenements/mairie",
  "/soiree-associative-2": "/soirees-evenements/mairie",
  "/dj-pour-soirees-comite-dentreprise": "/soirees-evenements/entreprise",
  "/dj-baptemes-communions": "/soirees-evenements/baptemes",
  "/dj-camping": "/soirees-evenements/camping",
  "/dj-soiree-privee-provence-vaucluse-bouches-du-rhone-avignon-cavaillon":
    "/soirees-evenements/soiree-privee",
  "/dj-saint-sylvestre-jour-de-l-an": "/dj-saint-sylvestre",
  "/dj-anniversaire": "/dj-anniversaire/avignon",
  "/dj-anniversaire-vaucluse-avignon": "/dj-anniversaire/avignon",

  // — Villes / mariage —
  "/dj-aix-en-provence": "/dj-mariage/aix-en-provence",
  "/dj-mariage-evangelique-provence": "/dj-mariage/evangelique",
  "/dj-mariage/evangelique-provence": "/dj-mariage/evangelique",
  "/dj-mariage-avignon": "/dj-mariage/avignon",
  "/dj-mariage-luberon": "/dj-mariage/luberon",
  "/dj-mariage-alpilles": "/dj-mariage/alpilles",
  "/dj-professionnel-vaucluse": "/dj-vaucluse",
  "/prestataire-dj-professionnel-en-lozere": "/dj-mariage",
  "/dj-mariage/aubenas": "/dj-mariage/orange",
  "/dj-mariage/valence": "/dj-mariage/orange",
  "/dj-mariage/privas": "/dj-mariage/orange",
  "/dj-mariage/montelimar": "/dj-mariage/orange",
  "/dj-mariage/aubagne": "/dj-mariage/salon",
  "/dj-mariage/toulon": "/dj-mariage/salon",
  "/dj-mariage/frejus": "/dj-mariage/salon",
  "/dj-mariage/beaucaire": "/dj-mariage/nimes",
  "/dj-mariage/millau": "/dj-mariage",
  "/dj-mariage/argeles": "/dj-mariage",

  // — Anciennes landings « vous-recherchez-un-dj-a-… » —
  "/vous-recherchez-un-dj-a-avignon": "/dj-mariage/avignon",
  "/vous-recherchez-un-dj-a-cavaillon": "/dj-mariage/cavaillon",
  "/vous-recherchez-un-dj-a-apt": "/dj-mariage/apt",
  "/vous-recherchez-un-dj-a-arles": "/dj-mariage/arles",
  "/vous-recherchez-un-dj-a-orange": "/dj-mariage/orange",
  "/vous-recherchez-un-dj-a-carpentras": "/dj-mariage/carpentras",
  "/vous-recherchez-un-dj-a-uzes": "/dj-mariage/uzes",
  "/vous-recherchez-un-dj-a-nimes": "/dj-mariage/nimes",
  "/vous-recherchez-un-dj-a-beaucaire": "/dj-mariage/nimes",
  "/vous-recherchez-un-dj-a-salon-de-provence": "/dj-mariage/salon",
  "/vous-recherchez-un-dj-a-saint-remy-de-provence-84": "/dj-mariage/saint-remy",
  "/vous-recherchez-un-dj-a-gordes": "/dj-mariage/luberon",
  "/vous-recherchez-un-dj-a-marseille": "/dj-mariage/bouches-du-rhone",
  "/vous-recherchez-un-dj-a-aubagne": "/dj-mariage/bouches-du-rhone",
  "/vous-recherchez-un-dj-a-toulon": "/dj-mariage/provence",
  "/vous-recherchez-un-dj-a-cannes": "/dj-mariage/provence",
  "/vous-recherchez-un-dj-a-saint-tropez": "/dj-mariage/provence",
  "/vous-recherchez-un-dj-a-digne-les-bains": "/dj-mariage/provence",
  "/vous-recherchez-un-dj-a-montelimar": "/dj-mariage/orange",
  "/vous-recherchez-un-dj-a-valence": "/dj-mariage/orange",
  "/vous-recherchez-un-dj-a-privas": "/soirees-evenements",
  "/vous-recherchez-un-dj-a-aubenas": "/soirees-evenements",
  "/vous-recherchez-un-dj-a-montpellier": "/dj-mariage",
  "/vous-recherchez-un-dj-a-perpignan": "/dj-mariage",
  "/vous-recherchez-un-dj-a-argeles": "/dj-mariage",
  "/vous-recherchez-un-dj-a-herault": "/dj-mariage",
  "/vous-recherchez-un-dj-a-mende": "/dj-mariage",
  "/vous-recherchez-un-dj-a-millau": "/dj-mariage",
  "/vous-recherchez-un-dj-a-rodez": "/dj-mariage",
  "/vous-recherchez-un-dj-a-hyeres": "/dj-mariage/provence",
  "/vous-recherchez-un-dj-a-frejus": "/dj-mariage/provence",
  "/prestations-et-tarifs-dj-vaucluse": "/tarifs",

  // — Génération pré-WordPress en .htm (toujours indexée par Google) —
  // Les clés sont minusculées : le lookup normalise le pathname.
  "/dj_mariage.n.htm": "/dj-mariage/vaucluse",
  "/dj_mairie.b.htm": "/soirees-evenements/mairie",
  "/dj_soiree_privee.e.htm": "/soirees-evenements/soiree-privee",
  "/soiree_fluo.nb.htm": "/soirees-thematiques/fluo",
  "/soiree_tempete_de_neige.h.htm": "/soirees-thematiques/tempete-de-neige",
  "/guirlande_lumineuse_guinguette.s.htm": "/location-materiel/guirlandes-guinguette",
  "/dj_carpentras.ab.htm": "/dj-mariage/carpentras",
  "/dj_salon_de_provence.fb.htm": "/dj-mariage/salon",
  "/dj_chateaurenard.cb.htm": "/dj-mariage/saint-remy",
  "/dj_digne_les_bains.bc.htm": "/dj-mariage/provence",
  "/dj_privas.db.htm": "/dj-mariage/orange",
  "/dj_herault.kb.htm": "/dj-mariage",
  "/dj_sete.nb.htm": "/dj-mariage",
  "/dj_agde.ob.htm": "/dj-mariage",


  // — Pages diverses —
  "/orcet-stephane-alias-dj-val": "/a-propos",
  "/realisations-sonorisation-eclairage-cavaillon-avignon": "/realisations",
  "/formulaire-client": "/contactez-nous",
  "/contact": "/contactez-nous",
  "/devis": "/contactez-nous",
  "/demande-de-devis": "/contactez-nous",
  "/devis-gratuit": "/contactez-nous",
  "/category/dj": "/actualites",
  "/blog": "/actualites",

  // — Articles (anciennes URLs WordPress) —
  "/2025/12/27/comment-choisir-le-dj-ideal-pour-votre-mariage":
    "/actualites/comment-choisir-le-dj-ideal-pour-votre-mariage",
  "/comment-choisir-le-bon-dj-pour-son-mariage":
    "/actualites/comment-choisir-le-dj-ideal-pour-votre-mariage",
  "/2025/12/27/dj-cavaillon-pour-mariage-lanimation-parfaite":
    "/actualites/dj-cavaillon-pour-mariage-animation-parfaite",
  "/dj-cavaillon-pour-mariage-lanimation-parfaite":
    "/actualites/dj-cavaillon-pour-mariage-animation-parfaite",
  "/dj-cavaillon-pour-mariage-lanimation-parfaite-2":
    "/actualites/dj-cavaillon-pour-mariage-animation-parfaite",
  "/actualites/dj-cavaillon-mariage-animation-2":
    "/actualites/dj-cavaillon-pour-mariage-animation-parfaite",
  "/actualites/prix-dj-mariage-vaucluse-2026":
    "/actualites/prix-dj-mariage-provence-guide-complet-2026",
  "/2025/12/27/quest-ce-quun-lumiere-led-mobile": "/actualites/lumiere-led-mobile",
  "/quest-ce-quun-lumiere-led-mobile": "/actualites/lumiere-led-mobile",
  "/2026/03/25/mariage-2026-les-tendances-musicales-et-ambiances-qui-font-vibrer-les-dancefloors":
    "/actualites/mariage-2026-tendances-musicales",
  "/2026/03/26/combien-coute-un-dj-pour-mariage-provence-2026":
    "/actualites/prix-dj-mariage-provence-guide-complet-2026",
  "/combien-coute-un-dj-pour-mariage-provence-2026":
    "/actualites/prix-dj-mariage-provence-guide-complet-2026",
  "/pourquoi-engager-un-dj-professionnel-pour-son-mariage":
    "/actualites/pourquoi-engager-un-dj-professionnel-pour-votre-mariage",
  "/faites-de-votre-mariage-une-fete-inoubliable-grace-a-une-animation-musicale-exceptionnelle":
    "/actualites/faites-de-votre-mariage-une-fete-inoubliable",
  "/les-tendances-de-mariage-pour-2023-sont": "/actualites/tendances-mariage-2026",
  "/actualites/tendances-mariage-2023": "/actualites/tendances-mariage-2026",
  "/guirlandes-guinguette-decoration-romantique-pour-mariage":
    "/actualites/guirlandes-guinguette-ambiance-festive",
};

/**
 * Préfixes d'anciennes URLs datées dont le slug varie (troncatures GSC).
 */
const DATED_PREFIX_REDIRECTS: Record<string, string> = {
  "/2026/03/25/mariage-2026-": "/actualites/mariage-2026-tendances-musicales",
  "/2026/03/26/combien-coute-un-dj-pour-mariage": "/actualites/prix-dj-mariage-provence-guide-complet-2026",
};

/**
 * URLs héritées du piratage/spam de l'ancien WordPress (fiches produits
 * e-commerce injectées). Elles doivent renvoyer 410 Gone pour être
 * désindexées vite, et non 404.
 */
const GONE_PATTERNS: RegExp[] = [
  /-t-\d{5,}$/i, // ex. /American-Flag-License-Plate-…-t-131944
  /^\/reviews\/product\//i,
  /^\/orders$/i,
  /^\/cart$/i,
  /^\/checkout$/i,
  /^\/wp-(admin|login|content\/uploads\/.*\.php)/i,
];

/** Normalise un pathname : minuscules, sans slash final. */
function normalize(pathname: string): string {
  return ("/" + pathname.replace(/^\/+/, "").replace(/\/+$/, "")).toLowerCase();
}

/** `true` si l'URL est un vestige de spam à désindexer (410 Gone). */
export function isGoneUrl(pathname: string): boolean {
  const p = normalize(pathname);
  return GONE_PATTERNS.some((re) => re.test(p));
}

/** Retourne la destination 301 pour un pathname, ou `null`. */
export function resolveLegacyRedirect(pathname: string): string | null {
  const normalized = normalize(pathname);

  const direct = LEGACY_REDIRECTS[normalized];
  if (direct) return direct;

  // Ancien préfixe WordPress « /location-avec-installation/<slug> » :
  // on retombe sur la règle du slug nu.
  const prefix = "/location-avec-installation/";
  if (normalized.startsWith(prefix)) {
    const bare = "/" + normalized.slice(prefix.length);
    return LEGACY_REDIRECTS[bare] ?? "/location-materiel";
  }

  // Anciennes URLs d'articles datées « /YYYY/MM/DD/<slug> », y compris
  // les slugs tronqués par Google Search Console (préfixes connus).
  for (const [prefix, target] of Object.entries(DATED_PREFIX_REDIRECTS)) {
    if (normalized.startsWith(prefix)) return target;
  }

  const dated = normalized.match(/^\/\d{4}\/\d{2}\/\d{2}\/(.+)$/);
  if (dated) {
    return LEGACY_REDIRECTS["/" + dated[1]] ?? "/actualites";
  }

  return null;
}
